import { Injectable } from '@angular/core';
import { HttpService } from '../providers/http.service';
import { AppConfig } from '../app/app.config';
import { PageDefault } from '../pages/PageDefault';


@Injectable()
export class ChaseReportService {

    constructor(
        private httpService: HttpService,
        private config:AppConfig) { }

        // username=this.config.getCurrentUser().UserName;

    //追号记录
    //TQQ 2017-01-02
    getCharseReport(input:CharseReportInput ) {
        var url = AppConfig.GetProdUrl() + "/Report/Chase";
        var param = "startDate=" + input.startDate + "&endDate=" + input.endDate + "&issue=" + input.issue + "&lotteryCode=" + input.lotteryCode + "&pageSize=" + input.pageSize + "&pageIndex=" + input.pageIndex + "&orderType=" + input.orderType + "&state=" + input.state+ "&userName=" + input.userName;
        return this.httpService.get(url + "?" + param);
    }
        //获取团队帐变记录
    //chen 2017-08-14
    getTeamChaseReport(input:TeamCharseReportInput) {
        let param = "start=" + input.start + "&end=" + input.end + "&pageSize=" + input.pageSize + "&pageIndex=" + input.pageIndex + "&userName=" + input.userName 
        + "&lotterycode=" + input.lotteryCode+ "&ordertype=" + input.orderType;
        let url = AppConfig.GetProdUrl() + "/Team/GetTeamChaseBettings?" + param;
        return this.httpService.get(url);
    }

      //获取所有彩种
    //TQQ 2017-01-02
    getAllLotterys() {
        let url = AppConfig.GetProdUrl() + "/Report/Lottery";
        return this.httpService.get(url);
    }

}

export class CharseReportInput {
    issue: string = "";
    state: string = "";
    userName: string = "";
    lotteryCode: string = "_ALL";
    orderType: string = "02";
    startDate: string = PageDefault.endNowDate();
    endDate: string = PageDefault.endDate();
    pageIndex: number = 1;
    pageSize: number = PageDefault.PageSize();
}
export class TeamCharseReportInput {
    userName: string = "";
    lotteryCode: string = "_ALL";
    orderType: string = "02";
    start: string = PageDefault.endNowDate();
    end: string = PageDefault.endDate();
    pageIndex: number = 1;
    pageSize: number = PageDefault.PageSize();
}


// WEBPACK FOOTER //
// ./src/services/chasereport.service.ts